/**
* 封禁设备详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 搜索条件 -->
		<div style="margin: 0 20px; display: flex; margin-top: 20px;">

			<el-input style="margin-left: 5px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input2"
				label-width="60px">
				<template slot="prepend">设备ID</template>
			</el-input>

			<el-input style="margin-left: 5px; margin-right: 10px;" placeholder="请输入内容" v-model="input3" label-width="60px">
				<template slot="prepend">用户ID</template>
			</el-input>

			<el-input style="margin-left: 5px; margin-right: 10px;" placeholder="请输入内容" v-model="input5"
				label-width="60px">
				<template slot="prepend">用户手机号</template>
			</el-input>

			<el-input style="margin-left: 5px; margin-right: 10px;" placeholder="请输入内容" v-model="input6"
				label-width="60px">
				<template slot="prepend">区号</template>
			</el-input>
			
			<el-input style="margin-left: 5px; margin-right: 10px;" placeholder="请输入内容" v-model="input7"
				label-width="60px">
				<template slot="prepend">IP</template>
			</el-input>

			<el-button style="margin-left: 5px;" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>

		</div>

		<!-- 列表 -->
		<el-table :data="tableData" height="200" stripe border
			style="width: 100%; flex: 1; overflow: auto; margin-top: 20px;" :default-sort="{ order: 'descending' }">
			<el-table-column type="index" :index="indexMethod"></el-table-column>
			<el-table-column prop="id" label="ID" align="center" width="80" sortable></el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="180" sortable></el-table-column>
			<el-table-column label="设备ID" align="center" width="300">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 12px;">{{ scope.row.deviceId }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="userId" label="用户ID" align="center" width="120"></el-table-column>
			<el-table-column prop="status" label="设备账号状态" align="center" width="120"></el-table-column>
			<el-table-column prop="country" label="国家" align="center" width="100"></el-table-column>
			<el-table-column prop="phoneNumber" label="手机号码" align="center" width="180"></el-table-column>
			<el-table-column prop="ip" label="IP" align="center"></el-table-column>


			<el-table-column label="操作" width="100" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="small">解封IP</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				input2: '', //设备ID
				input3: '', //用户ID
				input5: '', //用户手机号
				input6: '', //区号
				input7: '', //IP
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //获取被拉黑的IP
		},
		methods: {
			fetchData(pageNum, pageSize) { //获取被拉黑的IP

				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input2.length > 0) { //设备id 精确查询
					requestData.deviceId = this.input2;
				}
				if (this.input3.length > 0) { //用户id 精确查询
					requestData.userId = this.input3;
				}
				if (this.input5.length > 0) { //手机号码  精确查询
					requestData.phoneNumber = this.input5;
				}
				if (this.input6.length > 0) { //区号
					requestData.country = this.input6;
				}
				if (this.input7.length > 0) { //IP
					requestData.ip = this.input7;
				}
				

				axios.post(this.$p_url + '/admin/black/page/ip', requestData, {
						withCredentials: true, 
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("获取被拉黑的IP 数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据
							for (let i = 0; i < response.data.data.list.length; i++) {
								//将时间搓转换为正常的时间显示
								response.data.data.list[i].createTime = this.formatDate(response.data.data.list[i]
									.createTime);
								switch (response.data.data.list[i].status) { // 0-正常 1-禁言 2-被封禁
									case 0:
										response.data.data.list[i].status = "正常";
										break
									case 1:
										response.data.data.list[i].status = "禁言";
										break
									case 2:
										response.data.data.list[i].status = "被封禁";
										break
								}
							}
							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			deviceId(id) { //解封IP
				this.loadingData = true;
				const requestData = {}; //传递的参数
				requestData.id = id;

				axios.post(this.$p_url + '/admin/release/deviceId', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("解封IP 数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.fetchData(1, this.pageSize);
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			querySimCard(index) { //解封IP
				console.log('解封IP', this.tableData[index].id);
				this.deviceId(this.tableData[index].id);
			},
			search() { //单击了搜索
				console.log('开始时间/结束时间', this.startTime + "/" + this.endTime);
				console.log('信息序号/设备ID/用户ID', this.input1 + "/" + this.input2 + "/" + this.input3);
				console.log('用户昵称/用户手机号/手机品牌', this.input4 + "/" + this.input5 + "/" + this.input6);

				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			//...
		},
		//...
	}
</script>

<style>
	.container {
		display: flex;
		padding: 0px 10px;
	}

	.box {
		flex: 1;
		padding: 15px;
		width: 180px;
		height: 60px;
		margin: 10px;
		border-radius: 20px;
		/* 防止文本溢出 */
		overflow: hidden;
	}
</style>